<template>
  <div class="auth-wrapper">
    <div class="auth-header__menu main-clear">
      <router-link :to="{name:'Auth'}" class="prev-page" title="Назад"></router-link>
    </div>
    <div class="auth-content">
      <div class="auth-area">
        <Logo/>
        <Registration/>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
  import Registration from '@/components/auth/Registration.vue'
  import Logo from '@/views/auth/Logo.vue'
  import Footer from "@/views/auth/Footer";

  export default {
    name: 'Auth',
    metaInfo() {
      return {
        title: '"ИС-НЕЙВА", регистрация в системе',
      }
    },
    components: {
      Footer,
      Logo,
      Registration
    }
  }
</script>

